/**
 * Tool-action gerund labels for the chat streaming activity timeline.
 * Extracted verbatim from useChat.ts (PR6 Phase 2 decomposition) — no behavior change.
 */

/**
 * Simple gerund labels for tool actions — one word, natural English.
 * The receipt summary from the backend provides the "result" line.
 */
export const TOOL_GERUNDS: Record<string, string> = {
  // Data
  list_objects:      'Looking',
  get_object:        'Looking',
  read_asset:        'Reading',
  // CRUD
  create_object:     'Creating',
  update_object:     'Updating',
  delete_object:     'Deleting',
  restore_object:    'Restoring',
  // Links
  link_object:       'Linking',
  unlink_object:     'Unlinking',
  // Search
  search:            'Searching',
  semantic_search:   'Searching',
  search_internet:   'Searching',
  places_autocomplete: 'Looking',
  // Memory
  recall_memories:   'Checking',
  save_memory:       'Saving',
  forget_memory:     'Clearing',
  // Modules
  create_module:     'Creating',
  manage_module:     'Managing',
  create_data_module:'Creating',
  // Integrations
  connect_integration: 'Connecting',
  list_integrations: 'Checking',
  query_integration: 'Querying',
  sync_integration:  'Syncing',
  // Misc
  render_visualization: 'Rendering',
  aggregate_content: 'Gathering',
  flight_lookup:     'Looking',
  get_plugin_analytics: 'Checking',
  // Agent actions
  exec:              'Running',
  ui_action:         'Preparing',
  bash:              'Running',
  search_objects:    'Searching',
  memory:            'Checking memory',
  health_log:        'Logging',
  create_reminder:   'Setting reminder',
  profile_lookup:    'Looking up',
  skills_list:       'Checking skills',
  skill_view:        'Loading skill',
}

/** Get a specific label for a tool action, including object type when available */
export function getToolLabel(toolName: string, toolParams?: Record<string, unknown>): string {
  const gerund = TOOL_GERUNDS[toolName] || 'Working'
  if (!toolParams) return gerund + '...'

  const objectType = (toolParams.object_type || toolParams.objectType || '') as string
  if (objectType) return `${gerund} ${objectType}...`

  return gerund + '...'
}
